<div class="col-12 d-flex justify-content-center taosterdesign" *ngIf="isVisible" >
  <div class="col-10 text-center message">
     <img alt="Right_tick" [src]="tickmark" class="tickmark-css" > <span> {{ "label.common.popup." + message | translate }}</span>
  </div>
<div class="col-2 text-right" > 
  <custom-button  *ngIf="showbutton" class="homebuttom remove-button-shadow" margin="xxsmall" mode="secondary"
  label="{{ 'label.requirements.home' | translate }}" (onClick)="homepage()"> </custom-button>
</div>
</div>

<!-- <div class="footer" theme>
  <dxc-footer
    logoSrc="{{
      RESOURCE_SERVER_URL + '/assets/images/footer/DXC_Logo_white.svg'
    }}"
    copyright="{{ 'footer.rights' | translate }}"
    [socialLinks]="footerSocialLinks"
    [bottomLinks]="footerBottomLinks"
    margin="small"
  >
  </dxc-footer>
</div> -->
<div class="footer" theme>

  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-6 colsm-12 copy-rights">
      <span>{{'footer.rights'| translate}}</span>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 colsm-12 social-media-icons">
      <div class="row justify-content-end">
        <a target="_blank" href="https://www.facebook.com/DXCTechnology/" rel="noopener">
          <img src="{{ RESOURCE_SERVER_URL + '/assets/images/footer/facebook.svg' }}" alt="facebook">
        </a>
        <a target="_blank" href="https://twitter.com/dxctechnology" rel="noopener">
          <img src="{{ RESOURCE_SERVER_URL + '/assets/images/footer/twitter.svg' }}" alt="twitter">
        </a>
        <a target="_blank" href="https://www.linkedin.com/company/dxctechnology" rel="noopener">
          <img src="{{ RESOURCE_SERVER_URL + '/assets/images/footer/linkedin.svg' }}" alt="linkedin">
        </a>
      </div>
    </div>
  </div>
</div>